// 首先先调取桥接获取  uuid（设备id）、aeskey（aes秘钥）、aesUuid（aesuuid）、isOpen（加解密开关）、code

import { device, getParams } from '../utils'
import crypto from './aes'
import axios from 'axios'
import request from '../request.js'
const cryptoRsa = require('crypto')

var dataEncryp = {
    isEncrypt: 0,
    aesUuid: '',
    aesKey: ''
}

// 易卡app接口加密白名单
export const whiteList = [
    '/gateway/v1/config/basePageInfo',
    '/gateway/v1/activity/getProductList'
]
export const getIsInWhiteList = (path) => {
    return whiteList.some(item => {
        return path.endsWith(item)
    })
}
// 修改入参格式
const serialize = data => {
    const list = []
    Object.keys(data).forEach(ele => {
        list.push(`${ele}=${data[ele]}`)
    })
    return list.join('&')
}
const stringToHex = (str) => {
    var val = ''
    for (var i = 0; i < str.length; i++) {
        // 先转成unicode编码,再转成对应的16进制
        val += '' + str.charCodeAt(i).toString(16)
    }
    return val
}

// 加密的过程
export const doEncrypt = async (data, headers, method, Recryption) => {
    Recryption && crypto.setCryptoKey('')
    // 获取密钥和uuid
    if (dataEncryp.aesKey) { // && device.isGomePlus
        crypto.setCryptoKey(dataEncryp.aesKey)
    }
    if (crypto.key && Recryption) {
        data = crypto.encrypt(data)
        if (method.toLocaleLowerCase() === 'get') {
            data = {
                enData: data
            }
        }
        headers = Object.assign({}, headers, { decFlag: '2', aesUuid: dataEncryp.aesUuid, Recryption: Recryption || true })
    }
    return { data, headers }
}

// 处理接口加密降级
export const handleFechResult = (method, url, options, headers, res) => {
    // 记录接口请求尝试次数
    return new Promise((resolve, reject) => {
        if (getIsInWhiteList(url) && headers.Recryption && device.isGomePlus && getParams().source === 'plus') {
            try {
                res.data = crypto.decrypt(res.data)
            } catch (err) {
                console.log(err)
                console.log('明文返回')
            }
            headers.times++
            if (!res.code || res.code === '10403') {
                // 解密失败，降级处理
                if (headers.times <= 2) {
                    // 再次加密请求
                    resolve(featchDataApp({ method, url, options, headers, Recryption: true }))
                } else {
                    // 直接明文请求
                    // headers.decFlag = undefined
                    // headers.aesUuid = undefined
                    delete headers.aesUuid
                    delete headers.decFlag
                    resolve(featchDataApp({ method, url, options, headers, Recryption: false }))
                }
            } else {
                resolve(res)
            }
        } else if (res.code !== '10403') {
            resolve(res)
        } else {
            reject(res)
        }
    })
}
export const featchDataApp = async ({ method = 'post', url = '', options = {}, headers = {}, Recryption = true }) => {
    !headers.times && (headers.times = 1)
    headers.plant = 'H5'
    headers['Cache-Control'] = 'no-cache'
    var data = Object.assign({}, options)

    // if (Number(dataEncryp.isEncrypt) && getIsInWhiteList(url) && (device.isGomePlus && getParams().source === 'plus')) {
    if (getIsInWhiteList(url) && Recryption && device.isGomePlus && getParams().source === 'plus') {
        await initializeEncryption()
        const encryptedData = await doEncrypt(data, headers, method, Recryption)
        data = encryptedData.data
        headers = encryptedData.headers
    }
    if (method.toLocaleLowerCase() === 'get') {
        return axios({ method, url, params: data, headers }).then(res => {
            console.log('接口返回数据-get', res.data)
            return handleFechResult(method, url, options, headers, res.data)
        })
    } else {
        if (Number(headers.format)) {
            data = serialize(data)
        }
        return axios({ method, url, data: data, headers }).then(res => {
            console.log('接口返回数据-post', res.data)
            return handleFechResult(method, url, options, headers, res)
        })
    }
}

// 随机数
export const randomNumber = (n) => {
    const chars = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    var res = ''
    for (var i = 0; i < n; i++) {
        var id = Math.ceil(Math.random() * 61)
        res += chars[id]
    }
    return res
}

// 生成UUId
export const creatAesuuid = async () => {
    const data = new Date().getTime()
    const num = 64 - data.toString().length
    const randomNum = await randomNumber(num)
    return (data + randomNum)
}

// 调用接口

export const initializeEncryption = async () => {
    const aesuuid = await creatAesuuid()
    // 生成aeskey
    const aesKey = randomNumber(16)
    dataEncryp.aesUuid = aesuuid
    dataEncryp.aesKey = aesKey
    // 获取rsa公钥
    const resKey = await request.post('/gateway/v1/crypto/getRsaPublicKey', {
        params: {
            aesUuid: aesuuid
        },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            format: 1
        }
    })
    // 拼接公钥
    const publicKey = '-----BEGIN PUBLIC KEY-----' + resKey.data.publicKey + '-----END PUBLIC KEY-----'
    const encrypted = cryptoRsa.publicEncrypt({
        key: publicKey,
        padding: cryptoRsa.constants.RSA_PKCS1_PADDING
    }, Buffer.from(aesKey, 'utf-8')).toString('hex')
    // 第二步 上传aes秘钥
    const resAesKey = await request.post('/gateway/v1/crypto/saveAesKey', {
        params: {
            aesUuid: aesuuid,
            secretKey: encrypted
        },
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            format: 1
        }
    })
    if (resAesKey.code === '200') {
        dataEncryp.isEncrypt = '1'
    } else {
        dataEncryp.isEncrypt = '0'
    }
}
